import { Component, forwardRef, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReceiptCheckOptions } from 'src/app/api/api-campaigns.service.generated';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-receipt-check-options-edit',
  templateUrl: './receipt-check-options-edit.component.html',
  styleUrls: ['./receipt-check-options-edit.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ReceiptCheckOptionsEditComponent),
    multi: true
  }],
  imports: [
    ReactiveFormsModule,
    MatSlideToggleModule
  ]
})
export class ReceiptCheckOptionsEditComponent implements ControlValueAccessor, OnChanges {

  grp = new FormGroup({
    // hasOneLineItem: new FormControl({ disabled: true }),
    requiredReceiptDate: new FormControl(),
    requiredInvoiceNo: new FormControl(),
    requiredVendorName: new FormControl(),
    requiredVendorRawName: new FormControl(),
  });

  constructor() { }

  /// ControlValueAccessor-------------------
  @Input('value') _value;
  @Input('timeConstraint') _timeConstraint: boolean;
  onChange: any = () => { };
  onTouched: any = () => { };
  get value(): ReceiptCheckOptions {
    return this._value;
  }
  set value(o: ReceiptCheckOptions) {
    if (!o) o = new ReceiptCheckOptions({
      rules: [
        ReceiptCheckRule.HasOneLineItem,
        ReceiptCheckRule.RequiredReceiptDate,
        ReceiptCheckRule.RequiredInvoiceNo,
        ReceiptCheckRule.RequiredVendorName,
        ReceiptCheckRule.RequiredVendorRawName,
      ]
    });

    this._value = o;
    this.grp.patchValue({
      // hasOneLineItem:         o.rules.filter(r => r === ReceiptCheckRule.HasOneLineItem).length > 0,
      requiredReceiptDate: o.rules.filter(r => r === ReceiptCheckRule.RequiredReceiptDate).length > 0,
      requiredInvoiceNo: o.rules.filter(r => r === ReceiptCheckRule.RequiredInvoiceNo).length > 0,
      requiredVendorName: o.rules.filter(r => r === ReceiptCheckRule.RequiredVendorName).length > 0,
      requiredVendorRawName: o.rules.filter(r => r === ReceiptCheckRule.RequiredVendorRawName).length > 0
    });

    this.onChange(o);
    this.onTouched();
  }

  ngOnChanges(): void {
    const controlRequiredReceiptDate = this.grp.controls.requiredReceiptDate;

    controlRequiredReceiptDate?.setValue(this._timeConstraint);   //Sync with TimeConstraint toggle for manual verification when receipt no date
    this.value = this.getFormData();
    this._timeConstraint ? controlRequiredReceiptDate?.disable() : controlRequiredReceiptDate?.enable();  //Disable RequiredReceiptDate toggle when TimeConstraint toggle is on
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  onRuleChange() {
    this.value = this.getFormData();
  }

  getFormData(): ReceiptCheckOptions {
    const f = this.grp.value;

    const rules: ReceiptCheckRule[] = [ReceiptCheckRule.HasOneLineItem];
    // if (f.hasOneLineItem)         rules.push(ReceiptCheckRule.HasOneLineItem);
    if (f.requiredReceiptDate) rules.push(ReceiptCheckRule.RequiredReceiptDate);
    if (f.requiredInvoiceNo) rules.push(ReceiptCheckRule.RequiredInvoiceNo);
    if (f.requiredVendorName) rules.push(ReceiptCheckRule.RequiredVendorName);
    if (f.requiredVendorRawName) rules.push(ReceiptCheckRule.RequiredVendorRawName);

    return new ReceiptCheckOptions({ rules: rules });
  }
}

export enum ReceiptCheckRule {
  HasOneLineItem = 100,
  RequiredReceiptDate = 1000,
  RequiredInvoiceNo = 1001,
  RequiredVendorName = 1002,
  RequiredVendorRawName = 1003
}
